import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";

const DatesheetPT1 = () => {
  useEffect(() => {
    document.title = "Datesheet - St Peters Convent School Faridabad Haryana";
  }, []);

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Academics</li>
          <li>Datesheet</li>
          <li>PT -1</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Datesheet PT-1</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4">
              <div className="sample-blk">
                <div>
                  <p>DATESHEET(III- XI)</p>
                  <p>
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/DATESHEET(III-XI)_PT-1.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click here
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="sample-blk">
                <div>
                  <p>ASSESSMENT NURSERY</p>
                  <p>
                    <a
                      href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/pdf/assessment_1_nur.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click here
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DatesheetPT1;


